// extracted by mini-css-extract-plugin
module.exports = {"captchaDialog":"_1jhBz","blockingLayer":"_3uHl_","dialog":"_3iD4S","wrapper":"_1p53U","xButton":"_26OVl","content":"_1J8hK","title":"_35tG0","subtitle":"s0Hcx"};